import React, { createContext, useCallback, useContext, useMemo, useReducer } from 'react';

const defaultNotificationSettingsState = {
  channelDetailsArray: [],
  loadingChannelDetails: false,
  channelEventDetailsArray: [],
};

const NotificationSettingsContext = createContext(defaultNotificationSettingsState);

const actions = {
  SET_DATA: 'SET_DATA',
  CLEAR_DATA: 'CLEAR_DATA',
};

const actionsReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case actions.SET_DATA:
      return {
        ...state,
        ...payload.data,
      };
    case actions.CLEAR_DATA:
      return defaultNotificationSettingsState;
    default:
      return state;
  }
};

export const NotificationSettingsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(actionsReducer, defaultNotificationSettingsState);

  const setData = useCallback((data) => {
    dispatch({
      type: actions.SET_DATA,
      payload: { data },
    });
  }, []);

  const clearData = useCallback(() => {
    dispatch({
      type: actions.CLEAR_DATA,
    });
  }, []);

  const value = useMemo(() => ({ state, setData, clearData }), [clearData, setData, state]);

  return <NotificationSettingsContext.Provider value={value}>{children}</NotificationSettingsContext.Provider>;
};

export const useNotificationSettings = () => useContext(NotificationSettingsContext);
